/* ///////////////////////////////////////////////////// */
// Canvas aspect ratio = 480/80, 
// Indices chart aspect ratio = 350/80, 0.7291 of canvas width
// Projection chart aspect ratio = 200/80, 0.4166 of canvas width
/* ///////////////////////////////////////////////////// */

jQuery(function(){
  if ($('.line-chart').length === 0) { return; }

  const baseUrl = $('#base-url').data('base-url');

  // Canvas aspect ratio is 484 / 148

  const icons = [
    baseUrl + "themes/custom/gsod/src/assets/icons/icon-representative-government-white.svg",
    baseUrl + "themes/custom/gsod/src/assets/icons/icon-fundamental-rights-white.svg",
    baseUrl + "themes/custom/gsod/src/assets/icons/icon-checks-on-government-white.svg",
    baseUrl + "themes/custom/gsod/src/assets/icons/icon-impartial-administration-white.svg",
    baseUrl + "themes/custom/gsod/src/assets/icons/icon-participatory-engagement-white.svg",
  ];

  const titles = [
    'Representative Government',
    'Fundamental Rights',
    'Checks on Government',
    'Impartial Administration',
    'Participatory Engagement'
  ];

  // Call API to get chart data
  const lid = $('#country-data').data('lid'); // Local
  const nid = $('#country-data').data('nid'); // GSIDi site
  // Canvas use
  const canvasHeightRatio = 0.30578; // Canvas height devide by canvas width
  const ProjectionsChartWidthRatio = 0.3333; // To be remove
  const chartStartYRatio = 0.27027; // Vertical position in percentage to start drawing chart from bottom of canvas
  const chartHeightRatio = 0.54054; // Line chart height in percentage of total canvas's height

  let resizeTimeout;
  let wWidth = $(window).width();
  // Canvas variables, value will be generate from API's data
  let chartInterval;
  let pastDataStartYear;
  let pastDataEndYear;
  let projectedDataStartYear;
  let projectedDataEndYear;
  let totalSegments;
  let indicesData;
  let pastDataChartWidthRatio;

  // API settings
  const settings = {
    "url": baseUrl + "api/idea_country/recentideaindices?country_id="+lid+"&nid="+nid,
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/json"
    },
    error: function(error) {
      console.log('error', error);
    }
  };

  // console.log('API url:', settings.url);

  // Call API to get chart data
  $.ajax(settings).done(function (response) {
    indicesData = JSON.parse(response);
    // console.log('indicesData', indicesData);

    pastDataStartYear = indicesData[0].past_data[0].label;
    pastDataEndYear = indicesData[0].past_data[indicesData[0].past_data.length - 1].label;
    projectedDataStartYear = indicesData[0].projected_data[0].label;
    projectedDataEndYear = indicesData[0].projected_data[indicesData[0].projected_data.length - 1].label;

    // FOR CHART WITH PROJECTED VALUES ///////////////////////////////////////////////////////
    // totalSegments = projectedDataEndYear - pastDataStartYear;
    totalSegments = pastDataEndYear - pastDataStartYear;
    // ///////////////////////////////////////////////////////////////////////////////////////

    pastDataChartWidthRatio = parseFloat(((pastDataEndYear - pastDataStartYear) / totalSegments).toFixed(3));

    chartInterval = parseFloat((100 / totalSegments).toFixed(3));

    drawSidebarIndicesCharts();
    drawCharts();

    $('.loading-blocker.line-chart').fadeOut(1000, function(){
      $(this).remove();
    });
  });

  function addZeroAtTheEnd(text) {
    // Make sure number is in 2 decimals
    if (text == "0") {
      return "0.00";
    } else if ((text + "").length < 4) {
      return text+= "0";
    } else {
      return text;
    }
  }

  function renderTooltip(elm, year, value, x, y) {
    if (elm.find('.line-chart-tooltip').length > 0) {
      elm.find('.line-chart-tooltip span.tooltip-year').text(year);
      elm.find('.line-chart-tooltip span.tooltip-value').text(addZeroAtTheEnd(value));
    } else {
      const html = '<div class="line-chart-tooltip ' +
                      'absolute -translate-x-1/2 -translate-y-full pb-3 ' +
                      'pointer-events-none">' +
                      '<div class="bg-white drop-shadow-tooltip font-aileron font-bold text-gsodBody text-xs whitespace-nowrap px-4 py-2">' +
                        '<span class="tooltip-year">' + year + '</span> - <span class="tooltip-value">' + value + '</span>' +
                      '</div>' +
                    '</div>';

      elm.find('canvas').parent().append(html);
    }

    elm.find('.line-chart-tooltip').css('top', y +'px');
    elm.find('.line-chart-tooltip').css('left', x +'px');
  }

  // Begin
  function drawCharts() {
    // Loop through .line-chart canvas element
    $('.line-chart canvas').each(function(index) {
      const thisElm = $(this);
      let canvas = $(this)[0];
      let ctx = canvas.getContext("2d");

      // Set canvas wrapper (parent) element's aspect ratio
      $(this).parent().css('padding-top', ($(this).parent().width() * canvasHeightRatio) + 'px');
  
      // Make canvas resolution 2X
      canvas.width = canvas.getBoundingClientRect().width * 2;
      canvas.height = canvas.width * canvasHeightRatio;
  
      // const dataIndices = $(this).data('indices');
      // const dataProjections = $(this).data('projections');
  
      // Drawing chart title and icon
      drawHeader(canvas, ctx, icons[index], titles[index]);

      // Map chart value into a single array
      passData = indicesData[index].past_data.map((d, i) => { return d.value; });

      // passData=[0.3, 0.9, 0.1, 0.9, 0.1, 0.9, 0.1, 0.9, 0.1, 0.9];

      drawIndices(canvas, ctx, passData, thisElm);

      projectedData = indicesData[index].projected_data.map((d, i) => { return d.value; });

      // Last value of pass data for starting X position of projected data line
      const startAtXValue = passData[passData.length - 1];
      // Project line starting x coordinate
      const startAtX = canvas.width * pastDataChartWidthRatio;

      drawProjections(canvas, ctx, projectedData, startAtX, startAtXValue);

      drawFooter(canvas, ctx, '2012', '2021');
    })
  }

  // Draw pass indices data
  function drawIndices(canvas, ctx, data, elm) {  
    const cvWidth = canvas.width;
    const cvHeight = canvas.height;

    ctx.strokeStyle = "#2260DA";
    ctx.lineWidth = 3;
    
    let x;
    let y;

    let coordinates = [];

    // Drawing Big number + /1 ////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////
    // Drawing "/1" behind big indice number
    let fontSize; // Font size for big number

    let textY = 64;

    if (wWidth < 640) {
      fontSize = 40;
      textY = 36;
    } else if (wWidth >= 1024 && wWidth < 1280)  {
      fontSize = 84;
      textY = 100;
    } else {
      fontSize = 72;
    }

    let fontSizeSub =  Math.floor(fontSize * 0.5); // Font size for "/1";

    fontSizeSub = fontSizeSub + 'px';
    ctx.font = "bold " + fontSizeSub + " aileron";

    const textWidthSub = ctx.measureText(" /1").width;
    // FOR CHART WITH PROJECTED VALUES ///////////////////////////////////////////////////////
    // const textX = (pastDataChartWidthRatio * cvWidth) - (textWidthSub / 2);
    let textX = cvWidth - textWidthSub;
    // ///////////////////////////////////////////////////////////////////////////////////////

    ctx.fillStyle = 'white';
    ctx.fillText(' /1', textX, textY);

    // Drawing past data end year value (Big number)
    let text = data[data.length - 1] + "";

    text = addZeroAtTheEnd(text);

    fontSize = fontSize + 'px';
    ctx.font = "bold " + fontSize + " aileron";

    const textWidth = ctx.measureText(text).width;
    // FOR CHART WITH PROJECTED VALUES ///////////////////////////////////////////////////////
    // textX = (pastDataChartWidthRatio * cvWidth) - (textWidth / 2);
    textX = cvWidth - textWidth - textWidthSub;
    // ///////////////////////////////////////////////////////////////////////////////////////

    ctx.fillStyle = 'white';
    ctx.fillText(text, textX, textY);


    // Drawing Big number + /1 ////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////// END //















    function drawLineChart(showTooltip = false, coordinatesIndex = -1) {
      const cvWidth = canvas.width;
      const cvHeight = canvas.height;
      const canvasPadding = 30; // Canvas padding on all sides
      const chartTop = (cvHeight * chartStartYRatio);
      const chartWidth = cvWidth - canvasPadding;
      const chartHeight = cvHeight * chartHeightRatio;
      const chartBottom = chartTop + chartHeight;

      // const minIndice = Math.min(...data);
      const minIndice = 0;
      // const maxIndice = Math.max(...data);
      const maxIndice = 1;
      const yAxisRange = parseFloat(maxIndice - minIndice).toFixed(3);
      const xInterval = chartWidth / (data.length - 1)

      ctx.clearRect(0, chartTop - (canvasPadding / 2), cvWidth, chartHeight + (canvasPadding * 1.5));
      
      // ctx.fillStyle = 'black';
      // ctx.fillRect(0, chartTop, cvWidth, chartHeight);



      // Drawing dots on data points
      x = 0 + (canvasPadding / 2);
      // This will draw Y axis as min is 0 and max is 1
      // y = canvas.height - (data[0] * canvas.height);
  
      // This will draw Y axis base on min max value of indice data
      y = chartBottom - (Math.floor((parseFloat((data[0] - minIndice).toFixed(3)) / yAxisRange) * chartHeight));
      
      // Draw dot on initial data point
      // ctx.beginPath();
      //   ctx.arc(x, y, 5, 0, 2 * Math.PI);
      //   ctx.fillStyle = "#2260DA";
      //   ctx.fill();
      // ctx.closePath();

      // for (i=1; i<=9; i++) {
      //   x+= xInterval;
      //   y = chartBottom - (Math.floor((parseFloat((data[i] - minIndice).toFixed(3)) / yAxisRange) * chartHeight));

      //   ctx.beginPath();
      //     ctx.arc(x, y, 5, 0, 2 * Math.PI);
      //     ctx.fillStyle = "#2260DA";
      //     ctx.fill();
      //   ctx.closePath();
      // }



      // Drawing the line chart /////////////////////////////////////////////////////////////////////////
      x = 0 + (canvasPadding / 2);
      // This will draw Y axis as min is 0 and max is 1
      // y = chartBottom - (chartHeight * data[0]);

      // This will draw Y axis base on min max value of indice data
      y = chartBottom - (Math.floor((parseFloat((data[0] - minIndice).toFixed(3)) / yAxisRange) * chartHeight));

      ctx.beginPath();
      // Line chart starting coordinate
      ctx.moveTo(x, y);
    
      coordinates[0] = { x, y };

      for (i=1; i<data.length; i++) {
        // x = (cvWidth * chartInterval / 100) * i;
        x+= xInterval;
        // x = Math.floor(x);
        
        // This will draw Y axis as min is 0 and max is 1
        // y = chartBottom - (chartHeight * data[i]);

        // This will draw Y axis base on min max value of indice data
        y = chartBottom - (Math.floor((parseFloat((data[i] - minIndice).toFixed(3)) / yAxisRange) * chartHeight));
        
        ctx.lineTo(x, y);

        coordinates[i] = { x, y };
      }
    
      ctx.stroke();
      ctx.closePath();
    
      // Drawing gradient tone under past data line chart //////////////////////////////////////////////
      let grd = ctx.createLinearGradient(cvWidth / 2, chartTop, cvWidth / 2, chartBottom);
      grd.addColorStop(0, "#2260DA55");
      grd.addColorStop(1, "#2260DA00");

      x = 0 + (canvasPadding / 2);
      y = chartBottom - (Math.floor((parseFloat((data[0] - minIndice).toFixed(3)) / yAxisRange) * chartHeight));

      ctx.beginPath();
        ctx.moveTo(x, chartBottom);
        ctx.lineTo(x, y);
      
        for (i=1; i<data.length; i++) {
          // x = (cvWidth * chartInterval / 100) * i;
          x+= xInterval;
          y = chartBottom - (Math.floor((parseFloat((data[i] - minIndice).toFixed(3)) / yAxisRange) * chartHeight));

          ctx.lineTo(x, y);
        }
      
        ctx.lineTo(x, chartBottom);
      ctx.closePath();

      ctx.fillStyle = grd;
      ctx.fill();

      if (showTooltip) {
        ctx.beginPath();
          ctx.arc(coordinates[coordinatesIndex].x, coordinates[coordinatesIndex].y, 15, 0, 2 * Math.PI);
          ctx.fillStyle = "#2260DA";
          ctx.fill();
        ctx.closePath();
      }
    }

    drawLineChart();

    canvas.addEventListener('mousemove', function(e) {
      const rect = canvas.getBoundingClientRect();

      // * 2 because canvas is at 2x scale
      const mx = Math.floor((e.clientX - rect.left)) * 2;
      const my = Math.floor((e.clientY - rect.top)) * 2;

      let showTooltip = false;
      let coordinatesIndex;

      $.each(coordinates, function(index) {
        // x y of indices
        const x = $(this)[0].x;
        const y = $(this)[0].y;
        const distance = Math.sqrt(
          ((mx - x) * (mx - x))
          +
          ((my - y) * (my - y))
        );
      
        if (distance <= 15) {
          showTooltip = true;
          coordinatesIndex = index;
          renderTooltip(elm.parent(), pastDataStartYear + coordinatesIndex, data[coordinatesIndex], (x / 2), (y / 2));
        }
      })

      if (showTooltip) {
        drawLineChart(true, coordinatesIndex);
      } else {
        drawLineChart();
        elm.parent().find('.line-chart-tooltip').remove();
      }
    
      // drawDot(cvW / 2, cvH / 2, mx, my);
    });

    canvas.addEventListener('mouseleave', function(e) {
      drawLineChart();
      elm.parent().find('.line-chart-tooltip').remove();
    });
  }

  function drawProjections(canvas, ctx, data, startAtX, startAtXValue) {
    // REMOVE FOR CHART WITH PROJECTED VALUES ////////////////////////////////////////////////
    return;
    // ///////////////////////////////////////////////////////////////////////////////////////
    
    const cvWidth = canvas.width;
    const cvHeight = canvas.height;

    const chartTop = (cvHeight * chartStartYRatio);
    const chartHeight = cvHeight * chartHeightRatio;
    const chartBottom = chartTop + chartHeight;
    
    ctx.strokeStyle = "#FFFFFF";
    ctx.setLineDash([4,4]);
    ctx.lineWidth = 1.5;

    ctx.beginPath();
    ctx.moveTo(startAtX, chartBottom - (chartHeight * startAtXValue));

    let x;
  
    for (i=0; i<data.length; i++) {
      x = startAtX + (cvWidth * chartInterval / 100) * (i + 1);
      ctx.lineTo(x, chartBottom - (chartHeight * data[i]));
    }
    ctx.stroke();
  }

  function drawHeader(canvas, ctx, icon, title) {
    var img = new Image();

    img.onload = function() {
      ctx.save();
        ctx.drawImage(img, 0, 0, canvas.width * 0.06, canvas.width * 0.06);
      ctx.restore();
    }
    img.src = icon;

    let fontSize;

    if (wWidth < 640) {
      fontSize = '24px';
    } else if (wWidth >= 1024 && wWidth < 1280)  {
      fontSize = '40px';
    } else {
      fontSize = '32px';
    }

    ctx.save();
      ctx.fillStyle = 'white';
      ctx.font = "bold " + fontSize + " aileron";
      ctx.fillText(title, canvas.width * 0.085, canvas.height * 0.125);
    ctx.restore();
  }

  function drawFooter(canvas, ctx, yearBegin, yearEnd) {
    let fontSize = '24px';
    let lineLength = 60;

    if (wWidth < 640) {
      fontSize = '20px';
      lineLength = 20;
    } else if (wWidth >= 1024 && wWidth < 1280)  {
      lineLength = 100;
    } else if (wWidth >= 1280 && wWidth < 1536) {
      lineLength = 30;
    }

    // Draw begin year
    ctx.fillStyle = 'white';
    ctx.font = "bold " + fontSize + " aileron";
    ctx.fillText(yearBegin, 0, canvas.height);

    const chartWidth = (pastDataChartWidthRatio * canvas.width);
    const textWidthYearEnd = ctx.measureText(yearEnd).width;

    
    // FOR CHART WITH PROJECTED VALUES ///////////////////////////////////////////////////////
    // const textXYearEnd = chartWidth - (textWidthYearEnd / 2);
    const textWidth = ctx.measureText(yearEnd).width;
    const textXYearEnd = canvas.width - textWidth;
    // ///////////////////////////////////////////////////////////////////////////////////////

    ctx.fillText(yearEnd, textXYearEnd, canvas.height);

    // REMOVE FOR CHART WITH PROJECTED VALUES ////////////////////////////////////////////////
    return;
    // ///////////////////////////////////////////////////////////////////////////////////////

    ctx.fillStyle = "#FFFFFF66";

    ctx.font = "bold " + '16px' + " aileron";

    const textWidthProjected = ctx.measureText('PROJECTED').width;

    const textXProjected = canvas.width - textWidthProjected;
    ctx.fillText('PROJECTED', textXProjected, canvas.height);
    
    // Mid point of dotted line
    const midPoint = (textXYearEnd + textWidthYearEnd) + (textXProjected - (textXYearEnd + textWidthYearEnd)) / 2;
    const lineX = midPoint - (lineLength / 2);
    const lineY = canvas.height - 7;

    ctx.strokeStyle = "#FFFFFF66";
    ctx.setLineDash([4,4]);
    ctx.lineWidth = 1.5;

    ctx.beginPath();
      ctx.moveTo(lineX, lineY);
      ctx.lineTo(lineX + lineLength, lineY);
      ctx.stroke();
    ctx.closePath();
  }

  $(window).on('resize', function(){
    wWidth = $(window).width();

    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
      drawSidebarIndicesCharts();
      drawCharts();
    }, 100);
  });

  // For side bar indices data
  function drawSidebarIndicesCharts() {
    $('.sidebar-indices-data').each(function(index) {
      const thisElm = $(this);
      const data = indicesData[index].past_data.map((d, i) => { return d.value; });
      let coordinates = [];

      // const data = [1, 1, 1, 1, 1, 0, 0.9, 0.3, 0.8, 0.2];
      
      const minIndice = Math.min(...data);
      // const minIndice = 0;
      const maxIndice = Math.max(...data);
      // const maxIndice = 1;
      const yAxisRange = (parseFloat(maxIndice - minIndice).toFixed(3) == 0.000 ? 1 : parseFloat(maxIndice - minIndice).toFixed(3));
      const canvasPadding = 20; // Canvas padding on all sides

      // Get value of last year
      let lastYearIndice = data[data.length - 1] + "";
  
      if (lastYearIndice == "0") {
        lastYearIndice = "0.00";
      } else if (lastYearIndice.length < 4) {
        lastYearIndice+= "0";
      }
  
      thisElm.find('.last-year-indice').html(lastYearIndice+'&nbsp;<span class="text-xs">/1</span>');

      let canvas = thisElm.find('canvas')[0];
      let ctx = canvas.getContext('2d');

      canvas.width = canvas.getBoundingClientRect().width * 2;
      canvas.height = canvas.getBoundingClientRect().height * 2;

      const chartWidth = canvas.width - canvasPadding; // To have room on both sides
      const chartHeight = canvas.height - canvasPadding; // To have room on top and bottom

      function drawSidebarChart(showTooltip = false, coordinatesIndex = -1) {
        let x = 0;
        let y;
  
        const xInterval = chartWidth / (data.length - 1)

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // ctx.fillStyle = '#dddddd';
        // ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Drawing dots on data points
        x = 0 + (canvasPadding / 2);
        // This will draw Y axis as min is 0 and max is 1
        // y = canvas.height - (data[0] * canvas.height);
    
        // This will draw Y axis base on min max value of indice data
        y = Math.floor(chartHeight - ((parseFloat((data[0] - minIndice).toFixed(3)) / yAxisRange) * chartHeight)) + (canvasPadding / 2);
        
        // Draw dot on initial data point
        // ctx.beginPath();
        //   ctx.arc(x, y, 5, 0, 2 * Math.PI);
        //   ctx.fillStyle = "#2260DA";
        //   ctx.fill();
        // ctx.closePath();

        // for (i=1; i<=9; i++) {
        //   x+= xInterval;
        //   y = Math.floor(chartHeight - ((parseFloat((data[i] - minIndice).toFixed(3)) / yAxisRange) * chartHeight)) + (canvasPadding / 2);

        //   ctx.beginPath();
        //     ctx.arc(x, y, 5, 0, 2 * Math.PI);
        //     ctx.fillStyle = "#2260DA";
        //     ctx.fill();
        //   ctx.closePath();
        // }

        // Start drawing line
        x = 0 + (canvasPadding / 2);
        y = Math.floor(chartHeight - ((parseFloat((data[0] - minIndice).toFixed(3)) / yAxisRange) * chartHeight)) + (canvasPadding / 2);

        ctx.strokeStyle = "#2260DA";
        ctx.lineWidth = 4;
        ctx.beginPath();
        // Beginning of the line
        ctx.moveTo(x, y);
  
        coordinates[0] = { x, y };
  
        for (i=1; i<=9; i++) {
          x+= xInterval;
          // x = Math.floor(x);
          // This will draw Y axis as min is 0 and max is 1
          // y = canvas.height - (data[i] * canvas.height);
    
          // This will draw Y axis base on min max value of indice data
          y = Math.floor(chartHeight - ((parseFloat((data[i] - minIndice).toFixed(3)) / yAxisRange) * chartHeight)) + (canvasPadding / 2);
  
          ctx.lineTo(x, y);
          coordinates[i] = { x, y };
        }
  
        ctx.stroke();
        ctx.closePath();

        if (showTooltip) {
          ctx.beginPath();
            ctx.arc(coordinates[coordinatesIndex].x, coordinates[coordinatesIndex].y, 10, 0, 2 * Math.PI);
            ctx.fillStyle = "#2260DA";
            ctx.fill();
          ctx.closePath();
        }
      }

      drawSidebarChart();

      canvas.addEventListener('mousemove', function(e) {
        const rect = canvas.getBoundingClientRect();

        // * 2 because canvas is at 2x scale
        const mx = Math.floor((e.clientX - rect.left)) * 2;
        const my = Math.floor((e.clientY - rect.top)) * 2;

        let showTooltip = false;
        let coordinatesIndex;

        $.each(coordinates, function(index) {
          // x y of indices
          const x = $(this)[0].x;
          const y = $(this)[0].y;
          const distance = Math.sqrt(
            ((mx - x) * (mx - x))
            +
            ((my - y) * (my - y))
          );
        
          if (distance <= 15) {
            showTooltip = true;
            coordinatesIndex = index;
            renderTooltip(thisElm, pastDataStartYear + coordinatesIndex, data[coordinatesIndex], (x / 2), (y / 2));
          }
        })

        if (showTooltip) {
          drawSidebarChart(true, coordinatesIndex);
        } else {
          drawSidebarChart();
          thisElm.find('.line-chart-tooltip').remove();
      }
      });

      canvas.addEventListener('mouseleave', function(e) {
        drawSidebarChart();
        thisElm.find('.line-chart-tooltip').remove();
      });
    });
  }
});
